import React from 'react';
import BaseModal from 'src/common/components/Modal';
import { useHistory } from 'react-router-dom';

const ExistingUserModal = ({ open, setOpen, nameUser, onCreate }) => {
	const history = useHistory();

	const onVerify = () =>
		history.push('/administracion-de-usuarios/editar-usuario', nameUser);

	return (
		<BaseModal
			open={open}
			mainText="Se encontro coincidencia con otro usuario"
			confirmLabel="Verificar usuario"
			cancelLabel="No es el mismo usuario"
			onConfirm={onVerify}
			onCancel={() => onCreate()}
			onClose={() => setOpen(false)}
		>
			<h5>
				El sistema encontro un usuario con el mismo nombre, por favor verique que
				no se trate del mismo usuario que desea crear.
			</h5>
		</BaseModal>
	);
};

export default ExistingUserModal;
